import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-protein-search-page',
  templateUrl: './protein-search-page.component.html',
  styleUrls: ['./protein-search-page.component.css']
})
export class ProteinSearchPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

  selectedProperty = 'name';
  searchValue = "";

  data = {
    "TopDegree":[
      {
        "name": "RS27A_HUMAN",
        "date": "2781"
      },
      {
        "name": "UBB_HUMAN",
        "date": "2781"
      },
      {
        "name": "UBC_HUMAN",
        "date": "2781"
      },
      {
        "name": "RL40_HUMAN",
        "date": "2781"
      },
      {
        "name": "VIR_HUMAN",
        "date": "2687"
      },
      {
        "name": "A4_HUMAN",
        "date": "2548"
      },
      {
        "name": "NTRK1_HUMAN",
        "date": "2368"
      },
      {
        "name": "TPR_HUMAN",
        "date": "2272"
      },
      {
        "name": "TFG_HUMAN",
        "date": "2255"
      },
      {
        "name": "ESR2_HUMAN",
        "date": "2247"
      }
    ],
    "TopReferenceCount": [
      {
        "name": "ANDR_HUMAN",
        "count": 201
      },
      {
        "name": "P53_HUMAN",
        "count": 193
      },
      {
        "name": "A4_HUMAN",
        "count": 159
      },
      {
        "name": "HBB_HUMAN",
        "count": 137
      },
      {
        "name": "PSN1_HUMAN",
        "count": 136
      },
      {
        "name": "CFTR_HUMAN",
        "count": 126
      },
      {
        "name": "TTHY_HUMAN",
        "count": 125
      },
      {
        "name": "INSR_HUMAN",
        "count": 122
      },
      {
        "name": "CAH2_HUMAN",
        "count": 118
      },
      {
        "name": "MSH2_HUMAN",
        "count": 114
      },
    ],
    "up2date":[
      {
        "name": "DDX6_HUMAN",
        "count": "2019-06-05"
      },
      {
        "name": "DDX6_MOUSE",
        "count": "2019-06-05"
      },
      {
        "name": "RSMB_HUMAN",
        "count": "2019-06-05"
      },
      {
        "name": "RSSB_ECOLI",
        "count": "2019-06-05"
      },
      {
        "name": "RT12_YEAST",
        "count": "2019-06-05"
      },
      {
        "name": "RT31_HUMAN",
        "count": "2019-06-05"
      },
      {
        "name": "RT33_HUMAN",
        "count": "2019-06-05"
      },
      {
        "name": "RT34_HUMAN",
        "count": "2019-06-05"
      },
      {
        "name": "RT35_HUMAN",
        "count": "2019-06-05"
      },
      {
        "name": "RTL8C_HUMAN",
        "count": "2019-06-05"
      },
    ],
  }

}
